var _path, _path2, _ellipse, _circle, _path3, _polygon, _path4, _path5, _path6, _path7, _circle2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a7911dd8-4c59-47c4-8e89-f08275b909c0",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 902.09746,
    height: 742.06281,
    viewBox: "0 0 902.09746 742.06281",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M945.69481,680.39584c-18.17319,35.46508-41.224,69.76412-70.3892,100.80763-.64768.70106-1.30191,1.384-1.96193,2.07929l-69.10082-32.713c.42274-.70236.88624-1.49062,1.38456-2.35263,29.68322-50.787,208.86487-360.59146,203.20295-430.75835C1009.48992,323.24579,1030.72855,514.62775,945.69481,680.39584Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M888.6368,787.51457c-.96723.54979-1.959,1.088-2.95723,1.60811l-51.83786-24.54052c.72474-.51422,1.569-1.12219,2.53944-1.80589,15.88129-11.40253,63.10529-45.61328,109.31366-82.38043,49.658-39.51087,98.15212-81.96412,105.35392-102.22834C1049.58586,582.8143,1004.13425,724.06455,888.6368,787.51457Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#e6e6e6"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 267,
    cy: 715.62717,
    rx: 267,
    ry: 26.43564,
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120.80209,
    cy: 648.05071,
    r: 80,
    fill: "#3563be"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M301.79872,693.448H237.708a10.69385,10.69385,0,0,0-10.68177,10.68178v45.779A10.69381,10.69381,0,0,0,237.708,760.5906h64.09076a10.69382,10.69382,0,0,0,10.68181-10.68182v-45.779A10.69386,10.69386,0,0,0,301.79872,693.448Zm0,6.10388a4.55709,4.55709,0,0,1,1.13374.14789l-33.17168,26.46129-32.97773-26.51513a4.581,4.581,0,0,1,.92491-.09405Zm0,54.93484H237.708a4.58317,4.58317,0,0,1-4.5779-4.57794v-45.3679l34.711,27.90888a3.052,3.052,0,0,0,3.81549.00726l34.72013-27.69675v45.14851A4.58317,4.58317,0,0,1,301.79872,754.48672Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#fff"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "340.407 445.28 275.039 449.483 257.506 387.422 314.96 373.958 340.407 445.28",
    fill: "#2f2e41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M578.492,605.51982l17.90009.14725a12.45383,12.45383,0,0,0,12.3984-14.43007v0a12.45382,12.45382,0,0,0-17.80692-9.19146L574.103,590.37528l-57.73653,12.8756L491.63133,577.9617l-14.20818,23.401,33.378,25.78787Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#ffb8b8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M575.137,790.4585l-21.0895,4.05567c-14.40536-45.40853-30.013-88.41084-30.012-121.67018C503.6494,695.53294,478.369,708.51332,448.6,712.58958l3.24454-50.29034,24.334-12.97815,37.243-17.18908a28.28069,28.28069,0,0,1,10.36483-2.56388h0a28.28063,28.28063,0,0,1,29.41184,23.77347Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#ffb8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M571.89243,770.18014s2.02224-.85658,10.09824,9.71125c0,0,25.79022,4.80247,21.52492,16.43182s-37.426,11.26375-40.57724,9.48708-28.23273-1.74019-26.499-9.64142,11.72475-16.73206,11.72475-16.73206,4.59371,9.3079,11.73393,9.347c9.56095.05239,12.80549-8.059,11.18322-16.1703C571.0661,772.53753,571.95368,770.229,571.89243,770.18014Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M409.61135,742.522s3.15964,8.63711-11.06619,13.84121c0,0-13.95383,26.41871-25.15568,17.84333s.42261-44.511,3.42149-47.33621,11.45081-30.11151,19.45571-25.55113,14.22515,18.41448,14.22515,18.41448-25.775,8.27691-13.58211,27.43484C396.90972,747.16856,402.22575,747.52808,409.61135,742.522Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 290.13864,
    cy: 407.90843,
    r: 26.56097,
    fill: "#ffb8b8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M461.9837,557.25732H415.749l-9.73361-28.38971c16.87461-5.15073,12.933-19.77814,9.73361-34.06765H461.9837c-8.96327,17.87726-20.09875,43.17784,1.62227,47.85694Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#ffb8b8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M474.15072,706.50608l-8.40559,6.38824a26.03084,26.03084,0,0,1-25.66205,3.34538h0c-24.07541-18.04606-43.71077-12.638-59.21282,14.60042-18.59411-20.98528-20.65027-51.37887-4.05568-82.73572l92.06378,2.02783,18.65609-5.67794Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M443.49022,800.48525l0,0a23.50693,23.50693,0,0,1-27.81977-11.721c-8.27361-7.28739-15.25455-17.72094-21.30929-30.40862A235.35214,235.35214,0,0,1,383.194,729.67237c-4.18966-12.94009,2.81585-27.07679,15.85472-30.94809q.58159-.17268,1.17736-.32559c17.40628-4.46885,35.28122,5.57064,41.23113,22.52787l17.30115,49.30829A23.507,23.507,0,0,1,443.49022,800.48525Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#ffb8b8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M391.415,752.74074s20.27836,22.71177,24.334,35.68992",
    transform: "translate(-148.95127 -78.96859)",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M312.7676,645.55531l-6.78679,16.56425a12.45383,12.45383,0,0,0,8.79115,16.872h0a12.45383,12.45383,0,0,0,15.14908-13.11773l-1.4623-18.76695,9.4957-58.38766,32.66858-13.5696-16.44763-21.885-36.3425,21.40861Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M474.96185,648.10439c-23.30586,39.14729-60.78716,32.27676-100.58068,1.62227,16.78233-12.54764,6.48908-48.66808-8.11134-51.10148-15.09761-2.51627-16.91328-33.39206-22.71177-48.66807l70.5687-25.95631,19.06167,15.006,19.06166-4.46124,7.81479,2.773a26.41992,26.41992,0,0,1,17.58227,24.53686C461.633,584.99093,449.77787,609.6709,474.96185,648.10439Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#3563be"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M483.88433,616.47014s-3.59181-18.51977-15.3824-12.70721-12.60174-10.41012-12.60174-10.41012l9.32805-53.94045,38.12332,40.55673Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#3563be"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M463.89836,452.693s13.46093,5.04772,13.64919,22.96789a32.34842,32.34842,0,0,1-1.27476,8.9109c-.9047,3.28517-1.67052,10.42373,4.13385,20a184.66315,184.66315,0,0,1,10.2482,19.27125h0l-15.21893,1.33267-2.29135-25.22953a125.12513,125.12513,0,0,0-8.62394-35.61888l-.09618-.23767s-7.08336,12.063-20.33858,11.57218l4.9093-4.55871s-16.66168,6.10668-25.70271,7.28237a5.71887,5.71887,0,0,0-3.52817,9.47905q.07869.08767.16074.176c5.47046,5.89116,16.34125,19.56707,9.328,29.73647s-1.43763,13.22015-1.43763,13.22015L417.611,524.93078l-4.62883-3.01569-.14024,3.7872-24.51164-3.75192s-6.59255-1.19221,8.20546-16.762c0,0,3.98172-6.11159,2.54056-11.56328a27.21109,27.21109,0,0,1-.56275-12.75524C402.35235,463.23828,416.142,428.41243,463.89836,452.693Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "b82a9922-ead1-40af-af3b-f133b244cde7",
    "data-name": "Path 33",
    d: "M948.22812,251.91361h-4v-109.545a63.4,63.4,0,0,0-63.4-63.4h-232.087a63.4,63.4,0,0,0-63.4,63.4v600.974a63.4,63.4,0,0,0,63.4,63.4h232.086a63.4,63.4,0,0,0,63.4-63.4V329.88959h4Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#3f3d56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "b2a7827b-2d2c-407d-93be-35e4c67116bc",
    "data-name": "Path 34",
    d: "M883.38608,95.4616h-30.295a22.495,22.495,0,0,1-20.828,30.994h-132.959a22.495,22.495,0,0,1-20.827-30.991h-28.3a47.348,47.348,0,0,0-47.348,47.348v600.089a47.348,47.348,0,0,0,47.348,47.348H883.37711a47.348,47.348,0,0,0,47.348-47.348v-.00007h0v-600.092a47.348,47.348,0,0,0-47.348-47.348h.009Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "e6b07811-3d0f-4972-ba4c-46b0c6566e33",
    "data-name": "Ellipse 7",
    cx: 618.23084,
    cy: 651.74599,
    r: 26,
    fill: "#e6e6e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M661.70582,490.26682c-2.45763,0-4.45757,2.28274-4.45757,5.08789s1.99994,5.0879,4.45757,5.0879H871.84839c2.45763,0,4.45757-2.28274,4.45757-5.0879s-1.99994-5.08789-4.45757-5.08789Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#e6e6e6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M661.70582,610.26682c-2.45763,0-4.45757,2.28274-4.45757,5.08789s1.99994,5.0879,4.45757,5.0879H871.84839c2.45763,0,4.45757-2.28274,4.45757-5.0879s-1.99994-5.08789-4.45757-5.08789Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#e6e6e6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M661.70582,520.7942c-2.45763,0-4.45757,2.28274-4.45757,5.0879s1.99994,5.08789,4.45757,5.08789h90.425c2.45764,0,4.45757-2.28274,4.45757-5.08789s-1.99993-5.0879-4.45757-5.0879Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#e6e6e6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M661.70582,549.89259c-2.45763,0-4.45757,2.28274-4.45757,5.08789s1.99994,5.0879,4.45757,5.0879H871.84839c2.45763,0,4.45757-2.28274,4.45757-5.0879s-1.99994-5.08789-4.45757-5.08789Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#e6e6e6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M661.70582,580.42c-2.45763,0-4.45757,2.28274-4.45757,5.0879s1.99994,5.08789,4.45757,5.08789h90.425c2.45764,0,4.45757-2.28274,4.45757-5.08789s-1.99993-5.0879-4.45757-5.0879Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#e6e6e6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M701.37683,258.59576H832.19035a5.457,5.457,0,0,1,5.45054,5.45054V400.28321a5.457,5.457,0,0,1-5.45054,5.45054H701.37683a5.457,5.457,0,0,1-5.45054-5.45054V264.0463A5.457,5.457,0,0,1,701.37683,258.59576Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#3563be"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M804.31659,377.63922a3.70044,3.70044,0,1,0,0-7.40087h-75.066a3.70044,3.70044,0,1,0,0,7.40087Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M804.31659,355.83706a3.70044,3.70044,0,0,0,0-7.40088h-75.066a3.70044,3.70044,0,1,0,0,7.40088Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M766.78332,286.69029a23.29255,23.29255,0,1,1-23.29254,23.29254A23.31893,23.31893,0,0,1,766.78332,286.69029Z",
    transform: "translate(-148.95127 -78.96859)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/ForgotPassword.91c034ca879101e90d1e98cb98580a00.svg";
export { ForwardRef as ReactComponent };